import { areKeyboardShortcutsEnabled } from '../../react/features/keyboard-shortcuts/functions';
import { getKeyboardKey } from '../../react/features/keyboard-shortcuts/utils';
import WildixEvents from '../service/WildixEvents';
import WildixUIEvents from '../service/WildixUIEvents';

import { iAmVisitor } from '../../react/features/visitors/functions';

export default class WildixActions {
    constructor() {
        document.addEventListener(WildixEvents.CONFERENCE_JOINED, () => {
            this.keyup();
            if (!iAmVisitor(APP.store.getState)) {
                this.subscribeEvents();
            }
        });
    }

    subscribeEvents() {
        APP.wildix.eventEmitter.on(WildixUIEvents.PRIVATE_MESSAGE, this.focusOnElement.bind(this, '#usermsg'));

    }
    focusOnElement(selector) {
        const elementInput = document.querySelector(selector);

        if (elementInput) {
            elementInput.focus();
        }
    }

    keyup() {
        document.addEventListener('keyup', e => {
            if (typeof APP !== 'object') {
                return;
            }
            const state = APP.store.getState();

            if (!areKeyboardShortcutsEnabled(state) || APP.wildix.methods.disableShortcut()) {
                return;
            }
            const key = getKeyboardKey(e).toUpperCase();

            if (APP.isExternalProvider) {
                this.xBeesShortcuts(key);
            }

        });
    }

    xBeesShortcuts(key) {
        switch (key) {
        case 'C':
            APP.xBeesEvents.toggleChat(APP.store.getState()['features/chat'].isOpen);
            break;
        default:
            console.log('default');
        }
    }
}
